import { z } from 'zod';
import { CmsProjectQuestionSchema, ObjectiveSchema } from './applied-project';
export const CmsModuleActivitySchema = z.object({
    slug: z.string().min(1),
    title: z.string().min(1),
    summary: z.string().default(''),
    estimateSeconds: z.number().default(3600),
    isCore: z.boolean().default(true),
    description: z.string(),
    lesson: z.string(),
    difficulty: z.number().default(2),
    questions: z.array(CmsProjectQuestionSchema),
});
export const CmsModuleMissionSchema = z.object({
    slug: z.string().min(1),
    title: z.string().min(1),
    description: z.string().default(''),
    activities: z.array(CmsModuleActivitySchema),
});
export const CmsModuleWeekSchema = z.object({
    slug: z.string().min(1),
    title: z.string().min(1),
    description: z.string().default(''),
    missions: z.array(CmsModuleMissionSchema),
});
export const CmsModuleDefinitionSchema = z.object({
    title: z.string().min(1),
    slug: z.string().min(1),
    topic: z.string().min(1),
    description: z.string(),
    imageUrl: z.string().nullable().optional(),
    objectives: z.array(ObjectiveSchema).default([]),
    publishStatus: z.enum(['LIVE', 'ARCHIVED']).optional(),
    isProsumer: z.boolean().default(false),
    weeks: z.array(CmsModuleWeekSchema),
});
